import { baseTheme as theme } from "../../themes/base";
export const Variants = {
    h1: {
        tag: "h1",
        size: {
            xsmall: theme.fontTokens.font05,
            medium: theme.fontTokens.font03,
            large: theme.fontTokens.font02,
            xlarge: theme.fontTokens.font01,
        },
    },
    h2: {
        tag: "h2",
        size: {
            xsmall: theme.fontTokens.font06,
            medium: theme.fontTokens.font05,
            large: theme.fontTokens.font04,
            xlarge: theme.fontTokens.font03,
        },
    },
    h3: {
        tag: "h3",
        size: {
            xsmall: theme.fontTokens.font07,
            medium: theme.fontTokens.font06,
            large: theme.fontTokens.font05,
            xlarge: theme.fontTokens.font04,
        },
    },
    h4: {
        tag: "h4",
        size: {
            xsmall: theme.fontTokens.font08,
            medium: theme.fontTokens.font07,
            large: theme.fontTokens.font06,
            xlarge: theme.fontTokens.font05,
        },
    },
    h5: {
        tag: "h5",
        size: {
            xsmall: theme.fontTokens.font09,
            medium: theme.fontTokens.font08,
            large: theme.fontTokens.font07,
            xlarge: theme.fontTokens.font07,
        },
    },
    h6: {
        tag: "h6",
        size: {
            xsmall: theme.fontTokens.font10,
            medium: theme.fontTokens.font09,
            large: theme.fontTokens.font09,
            xlarge: theme.fontTokens.font09,
        },
    },
    h7: {
        tag: "h6",
        size: {
            xsmall: theme.fontTokens.font10,
            medium: theme.fontTokens.font10,
            large: theme.fontTokens.font10,
            xlarge: theme.fontTokens.font10,
        },
    },
    p1: {
        tag: "p",
        size: {
            xsmall: theme.fontTokens.font11,
        },
    },
    p2: {
        tag: "p",
        size: {
            xsmall: theme.fontTokens.font12,
        },
    },
    label1: {
        tag: "label",
        size: {
            xsmall: theme.fontTokens.font13,
        },
    },
    label2: {
        tag: "label",
        size: {
            xsmall: theme.fontTokens.font14,
        },
    },
};
